import { SET_NAV_DATA } from './types';

export const setNavData = (data) => {
  return {
    type: SET_NAV_DATA,
    payload: data,
  };
};
